(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["louford-tracking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forms = new WeakMap();
    const initialize = (scope) => {
      scope.querySelectorAll('[data-tracking-login]').forEach((form) => {
        if (forms.has(form)) return;
        const controller = new AbortController();
        forms.set(form, controller);
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          try {
            const url = new URL(form.dataset.loginUrl, window.location.origin);
            url.searchParams.set('login_hint', form.elements.login_hint.value.trim());
            if (form.dataset.legacyLogin === 'true' && !url.searchParams.has('return_url')) {
              url.searchParams.set('return_url', window.location.pathname + window.location.search);
            }
            if (form.dataset.designMode === 'true') {
              window.open(url.href, '_blank', 'noopener,noreferrer');
            } else {
              window.location.assign(url.href);
            }
          } catch (error) {
            form.querySelector('[data-login-error]').hidden = false;
          }
        }, { signal: controller.signal });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-tracking-login]').forEach((form) => {
        forms.get(form)?.abort();
        forms.delete(form);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
